import { antiForgeryGet } from "@/api_client";

function getCookieValue(cookieName: string): string {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [name, value] = cookie.split("=");
    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }
  return "";
}

const methodsNotRequiringAntiForgery = new Set([
  "GET",
  "HEAD",
  "OPTIONS",
  "TRACE",
]);

export function methodRequiresXsrfToken(method?: string) {
  return method
    ? !methodsNotRequiringAntiForgery.has(method.toUpperCase())
    : true;
}

export async function getXsrfToken(baseUrl?: string): Promise<string> {
  await antiForgeryGet(
    baseUrl ? { credentials: "include", baseUrl } : { credentials: "include" },
  );
  return getCookieValue("XSRF-TOKEN");
}
